// This is generated.  Alter it in blockGroups/formElements/types/TextLabel.js
/* eslint-disable no-unused-vars */
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode) {
    //a Label does not contribute to anything
    return [{}, {}];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'TextLabel',
  module.exports,
);
